import { useSettings } from "@/lib/settings";
import { imgUrl } from "@/lib/api";

export const LogoMark = ({ className = "h-9 w-9", ring = "rgb(var(--c-ink))", leaf = "rgb(var(--c-accent))", wave = "rgb(var(--c-paper))" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill={ring} />
    <path d="M32 10c-9 7-14 15-14 23 0 8 6 13 14 13s14-5 14-13c0-8-5-16-14-23z" fill="none" stroke={leaf} strokeWidth="3" />
    <path d="M32 16v30M32 26l-6-5M32 33l7-6M32 40l-6-4" stroke={leaf} strokeWidth="2.4" strokeLinecap="round" />
    <path d="M12 52c5-3 9-3 14 0s9 3 14 0 9-3 14 0" fill="none" stroke={wave} strokeWidth="2.6" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ light = false }) => {
  const s = useSettings();
  const brand = s?.brand || "Samara Beach House";
  const logo = s?.logo || {};
  const h = Number(logo.height) || 36;
  const showText = logo.show_text !== false;
  return (
    <span className="flex items-center gap-3" data-testid="site-logo">
      {logo.url ? <img src={imgUrl(logo.url)} alt={brand} style={{ height: h }} className="w-auto object-contain" /> : <LogoMark ring={light ? "transparent" : "rgb(var(--c-ink))"} />}
      {showText && (
        <span className="leading-none">
          <span className={`block font-display text-[15px] font-semibold uppercase tracking-[0.08em] sm:text-[21px] ${light ? "text-paper" : "text-ink"}`}>{brand}</span>
          <span className={`mt-0.5 hidden font-mono text-[10px] uppercase tracking-[0.3em] sm:block ${light ? "text-gold" : "text-brown"}`}>Guanacaste · Costa Rica</span>
        </span>
      )}
    </span>
  );
};
